
import React from 'react';
import ReactDOM from 'react-dom';

class ProductDetails extends React.Component
{
    constructor(props) {
        super(props);
        this.renderCodes = this.renderCodes.bind(this);
        this.unlinkBatch = this.unlinkBatch.bind(this);
        this.state = {
            details: {}
        };
    }

    componentWillMount()
    {
        let self = this;
        let details = self.props.details;

        self.setState({
            details: details
        });
    }

    componentDidMount()
    {
        let self = this;
    }

    renderCodes(item)
    {
        let pin = item.pin === "" ? "Sin pin asignado": item.pin;
        return(
            <tr key={item.id}>
                <td>{item.number}</td>
                <td>{pin}</td>
            </tr>
        );
    }

    unlinkBatch()
    {
        let self = this;
        let batch_id = self.state.details.batch.id;

        axios.put('/api/codes/unlink/' + batch_id)
            .then(response => {
                location.reload();
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al procesar tu solicitud.",
                    icon: "warning",
                });
            });

    }

    render()
    {
        return (
            <div key={this.state.details.batch.id}>
                <div style={{ marginBottom: "20px" }}>
                    <label>
                         Lote - {this.state.details.batch.id} - {this.state.details.batch.description}
                    </label>

                    <button className="btn btn-xs btn-danger pull-right" onClick={this.unlinkBatch}>
                        <i className="fa fa-times"></i> Desvincular
                    </button>

                    <br/>
                    <br/>

                    <table className="table table-bordered m-0">
                        <thead>
                        <tr>
                            <th className="col-md-6">Código</th>
                            <th className="col-md-6">Pin</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.details.codes.map(this.renderCodes)}
                        </tbody>
                    </table>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default ProductDetails;

if (document.getElementById('products_details-component')) {
    ReactDOM.render(<ProductDetails details={details}/>, document.getElementById('products_details-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/ProductDetails.jsx